// extracted by mini-css-extract-plugin
export default {"ConceptButton":"ConceptButton_ConceptButton__RpMON","button":"ConceptButton_button__MsK-u"};